import React from 'react';
import { Container } from '@mui/material';
import BattingStatsTable from '../components/BattingStatsTable';
import { API_ENDPOINTS } from '../config/api';

const SeasonBattingStatsPage = () => {
  return (
    <Container maxWidth="xl" sx={{ my: 4 }}>
      <BattingStatsTable apiUrl={API_ENDPOINTS.PLAYER_BATTING_STATS} />
    </Container>
  );
};

export default SeasonBattingStatsPage; 